import { FETCH_SINGLE_CUSTOMER } from '../actions/actiontypes';

export default function (state = {}, action) {
    switch (action.type) {
        case FETCH_SINGLE_CUSTOMER: {
            return { ...state, ...action.payload };
        }
        default:
            return state;
    }
}